<div class="d-flex flex-row align-items-center cbm-item">
    <div class="d-flex flex-row align-items-center" style="flex: 3">
        <div class="cmb-circle">

        </div>
        <div class="cbm-detail">
            <div class="detail-recommend">Top Recommended</div>
            <div class="detail-name">CBM NAME</div>
            <div class="detail-tags">
                <div>Most Awaited</div>
                <div>Excellent Customer Service</div>
                <div>Quick Response Time</div>
                <div>Good Quality of Work</div>
            </div>
            <div class="detail-view">
                View Details & Reviews
            </div>

        </div>
    </div>
    <div style="flex:1;">
            AAA
    </div>
    <div style="flex:1;">
        <img class="star" src="assets/img/icons/star.png" alt="star-icon"/>
        <img class="star" src="assets/img/icons/star.png" alt="star-icon"/>
        <img class="star star-inactive" src="assets/img/icons/star.png" alt="star-icon"/>
        <img class="star star-inactive" src="assets/img/icons/star.png" alt="star-icon"/>
        <img class="star star-inactive" src="assets/img/icons/star.png" alt="star-icon"/>
    </div>
</div>
